import React from 'react';
import './Popup.css';

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: '',
      count: 0
    }
  }
  popupClose = () => {
    if (this.state.count === 0) {
      this.setState({ count: 1 });
      this.setState({ hide: 'hide' });
    }
    else {
      this.setState({ count: 0 });
      this.setState({ hide: '' });
    }
  }
  render() {
    return (
      <div className={this.state.hide}>
        <div className="site-content">
          <div className="well">
            На нашем сайте мы используем cookie для сбора информации технического характера.<br />В
              частности, для персонифицированной работы сайта мы обрабатываем IP-адрес региона вашего
              местоположения.&nbsp;
                <button className="btn btn-primary btn-sm" onClick={this.popupClose}>OK</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Popup;
